<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">APOYOS O BENEFICIOS PÚBLICOS (HASTA LOS ÚLTIMOS 2 AÑOS) </legend>
        </div>

      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿Es beneficiario de algún programa público? <b-button class="btn-popover" v-b-popover.hover.top="info.apoyo"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de la participación en alguna institución de la pareja o dependientes económicos no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Beneficiario de algún programa público <b-button class="btn-popover" v-b-popover.hover.top="info.beneficiario"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group col-6">
            <label class="control-label">Señalar quien recibe los beneficios <b-button class="btn-popover" v-b-popover.hover.top="info.beneficiario"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" name="participante" v-validate="'required'" v-model="form_item.beneficiario">
              <el-option v-for="option in beneficiarios" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('participante')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre del programa <b-button class="btn-popover" v-b-popover.hover.top="info.programa"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="programa" v-validate="'required'" v-model="form_item.programa" placeholder="Nombre del programa">
            <small class="text-danger">{{ errors.first('programa')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Institución que otorga el apoyo <b-button class="btn-popover" v-b-popover.hover.top="info.institucion"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="institucion_otorgante" v-validate="'required'" v-model="form_item.institucion_otorgante" placeholder="Institución que otorga el apoyo">
            <small class="text-danger">{{ errors.first('institucion_otorgante')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nivel u orden de Gobierno <b-button class="btn-popover" v-b-popover.hover.top="info.nivel"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" filterable name="nivel_orden_gobierno_id" v-validate="'required'" v-model="form_item.nivel_orden_gobierno_id">
              <el-option v-for="option in nivel_gobierno" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('nivel_orden_gobierno_id')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de Apoyo <b-button class="btn-popover" v-b-popover.hover.top="info.tipo"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" filterable placeholder="Seleccione una opción" name="tipo_apoyo_id" v-validate="'required'" v-model="form_item.tipo_apoyo_id">
              <el-option v-for="option in tipos_apoyos" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_apoyo_id')}}</small>
          </div>
          <div class="form-group col-6" v-if=" form_item.tipo_apoyo_id == 4">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especificar" v-validate="'required'" v-model="form_item.especificar_tipo_apoyo" placeholder="Especificar">
            <small class="text-danger">{{ errors.first('especificar')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Forma de recepción del apoyo <b-button class="btn-popover" v-b-popover.hover.top="info.forma"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio class="d-inline-block" name="forma" v-validate="'required'" v-model="form_item.forma" label="1">Monetario</p-radio>
            <p-radio class="d-inline-block" name="forma" v-validate="'required'" v-model="form_item.forma" label="2">Especie</p-radio>
            <small class="text-danger">{{ errors.first('forma')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Monto aproximado del apoyo mensual <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0"></el-input-number>
            <!-- <input class="form-control" type="text" name="monto" v-validate="'required'" v-model="form_item.monto" placeholder="Monto aproximado"> -->
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.forma == '2'">
            <label class="control-label">Especifique el apoyol <b-button class="btn-popover" v-b-popover.hover.top="info.especificar_apoyo"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="especificar_apoyo" v-validate="'required'" v-model="form_item.especificar_apoyo" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especificar_apoyo')}}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones/observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones/observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.beneficiario="{ item }">
                <div>{{filterBeneficiario(item.beneficiario)}}</div>
              </template>
              <template v-slot:item.nivel_orden_gobierno_id="{ item }">
                <div>{{filterNivel(item.nivel_orden_gobierno_id)}}</div>
              </template>
              <template v-slot:item.tipo_apoyo_id="{ item }">
                <div>{{filterApoyo(item.tipo_apoyo_id)}}</div>
              </template>
              <template v-slot:item.monto="{ item }">
                <div>${{item.monto | currency}}</div>
              </template>
            </v-data-table>
            <!--  <b-table id="tbl_metales" responsive hover :items="table_list" :fields="fields_list" show-empty>
              <template slot="acciones" slot-scope="row" class="actions">
                <b-button size="sm" @click.prevent="editItem(row)" class="edit mr-2" > Editar <i class="fas fa-pencil-alt ml-2"></i>
                </b-button>
                <b-button size="sm" @click.prevent="removeItem(row.index)" class="delete mr-2" > Eliminar <i class="fas fa-trash-alt ml-2"></i>
                </b-button>
              </template>
              <template slot="empty">
                <h5>No existen registros</h5>
              </template>
            </b-table> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  /* import {
    mapState
  } from "vuex"; */
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        search: '',
        ip_id: 1,
        add_item: false,
        edit_item: null,
        niveles: [],
        apoyos: [],
        bandera: "0",
        isnum: null,
        /* Lista de metales */
        form_item: {},
        table_list: [],
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Beneficiario',
          value: 'beneficiario',
          align: 'center',
        }, {
          text: 'Nombre del programa',
          value: 'programa',
          align: 'center',
        }, {
          text: 'Nombre de la institución',
          value: 'institucion_otorgante',
          align: 'center',
        }, {
          text: 'Nivel u orden de gobierno',
          value: 'nivel_orden_gobierno_id',
          align: 'center',
        }, {
          text: 'Tipo de apoyo',
          value: 'tipo_apoyo_id',
          align: 'center',
        }, {
          text: 'Monto aproximado del apoyo mensual',
          value: 'monto',
          align: 'center',
        }, ],
        info: {
          apoyo: 'Es la contribución monetaria o en especie que otorga un Ente Público al Declarante, cónyuge o Pareja y/o dependiente económico. El apoyo en especie refiere a cualquier contribución, utilizando bienes, servicios o beneficios de naturaleza diferente al dinero. Deberá reportar hasta los últimos dos años.',
          beneficiario: 'Son las personas que reciben el apoyo o beneficio público. De las opciones del catálogo indicar quien o quienes son los beneficiarios, señalar las veces que sean necesarias.',
          programa: 'Proporcionar el nombre del programa por el cual recibe el apoyo o beneficio público.',
          institucion: 'Señalar el nombre de la institución que le esté dando el apoyo.',
          nivel: 'Seleccionar el orden de gobierno por medio del cual recibe el apoyo o beneficio público: federal, estatal o municipal/alcaldía.',
          tipo: 'Seleccionar del listado desplegable: subsidio (Ayuda económica que una persona recibe de un organismo oficial para satisfacer una necesidad determinada), servicio (Actividad o asistencia de un Ente Público, en favor del Declarante), Obra (materiales o servicios a favor del Declarante para construcción), otro, especifique.',
          forma: 'Señalar si el apoyo recibido es monetario o en especie.',
          monto: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda. Indicar cantidad mensual del apoyo, si este no fuera mensual, realizar la operación aritmética a efecto de establecer la cantidad como lo solicita el formato.',
          especificar_tipo: '(Otro) Especifique tipo de apoyo',
          especificar_apoyo: 'En caso de haber seleccionado en especie deberá describir en qué consiste el apoyo o beneficio.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {
      /* ...mapState(["tipo_apoyos", "nivel_gobierno"]), */
      /* ...mapFields(["programa", "institucion_otorgante", "nivel_orden_gobierno_id", "tipo_apoyo_id", "monto", "especificar_tipo_apoyo"]) */
    },
    watch: {
      /*form_item: {
        handler: function() {
          if (this.form_item) {

          }
        },
        deep: true
      },
       table_list: {
        handler: function() {
          if (this.table_list) {
            if (this.table_list.length == 0) {
              this.bandera = "0";
            } else {
              this.bandera = "1";
            }
          }
        },
        deep: true
      },
      bandera() {
        this.form_item.bandera = this.bandera;
      }*/
    },
    methods: {
      showItem() {
        this.add_item = true;
        this.$validator.resume();
      },
      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("apoyos", this.form_item).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
                //this.change =  true;
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("apoyos/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
    },
    created() {
      this.ip_id = this.getKey('uid');
      this.$http.get("apoyos/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
    },
    mounted() {
      this.checkCatalogs();
    }
  };

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/Apoyos.vue